<template>
  <div class="report-detail">
	  <div class="pdf-h" id="pdf" v-show="reportData.fileType == 1 && pdfh5"></div>
    <div class="img-group" :class="{'img-bottom': reportData.status == 3}" v-show="reportData.fileType == 2 && picList.length > 0">
      <img class="img-item" :src="item.filePath" @click="toPreview(index)" v-lazy="item.filePath" v-for="(item,index) in picList" :key="index">
    </div> 
    <div class="no-data" v-show="showNoData">
      <img class="img-icon" src="@/assets/images/m-report/no-data.png">
      <p class="desc">暂无报告信息</p>
    </div>
    <div class="upload-btn" v-show="reportData.status == 3">
      <button class="btn" @click="againUpload">重新上传</button>
    </div>
  </div>
</template>
<script>
  import Pdfh5 from "pdfh5";
  import { Toast, ImagePreview } from 'vant'
  export default {
  name: 'App',
	data() {
	  return {
	    pdfh5: null,
      reportData: {},
      picList: [],
      flag: false // 默认展示空白页
	  };
	},
  computed: { 
    showNoData() {
      return (this.picList.length == 0 && this.reportData.fileType == 2 && this.flag) || (this.reportData.fileType == 1 && this.pdfh5 && this.flag)
    }
  },
  methods: {
    // 初始化pdf预览插件
    initPdf() {
      this.flag = true
      this.pdfh5 = new Pdfh5("#pdf", {
        pdfurl: `${this.getApiUrl('reportPdf')}?id=${this.reportData.id}`
      });
      //监听完成事件
      this.pdfh5.on("complete", function (status, msg, time) {
        console.log("状态：" + status + "，信息：" + msg + "，耗时：" + time + "毫秒，总页数：" + this.totalNum)
      })
    },
    // 重新上传跳转
    againUpload() {
      this.$router.push({
        path: '/user/body-report/import',
        query: {
          fromDetail: 1
        }
      })
    },
    // 获取图片list
    async getPicUrlList() {
      let res = await this.axios.get(this.getApiUrl('picUrlList'), {
        params: {
          id: this.reportData.id
        }
      })
      if(res.code == 1) {
        res.data.sort((a,b) => {
          return a.position - b.position
        })
        this.picList = res.data
      }else{
        Toast(res.msg)
      }
      this.flag = true
    },
    // 图片预览
    toPreview(index) {
      let url = [];
      this.picList.forEach(item => {
        url.push(item.filePath)
      })
      ImagePreview({
        images: url,
        startPosition: index,
      })
    },
  },
	mounted() {
    document.title = "体检报告详情"
    this.reportData = JSON.parse(localStorage.getItem('reportData')) || {}
    console.log(this.reportData)
    if(this.reportData.fileType == 2) {
      this.getPicUrlList()
    } else {
      this.initPdf()
    }
	}
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/function.scss";
  .report-detail {
    position: relative;
    height: 100%;
    width: 100%;
    background-color: #fff;

  }
  .pdf-h {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
  }
  .upload-btn {
    position: fixed;
    padding: 0 getsize(45px);
    width: 100%;
    box-sizing: border-box;
    bottom: getsize(77px);
    left: 0;
    .btn {
      width: 100%;
      height: getsize(98px);
      border-radius: getsize(49px);
      font-size: getsize(36px);
      font-weight: bold;
      background: linear-gradient(270deg, #F55B44 0%, #FA7519 100%);
      box-shadow: 0px 6px 36px -16px #F55B43;
      color: #ffffff;
    }
  }
  .img-group {
    width: 100%;
    padding: getsize(40px) getsize(40px) 0;
    box-sizing: border-box;
    &.img-bottom {
      padding-bottom: getsize(200px);
    }
    .img-item {
      width: 100%;
      margin-bottom: getsize(20px);
    }
  }
  .no-data {
    padding-top: getsize(250px);
    text-align: center;
    .img-icon {
      width: getsize(260px);
      height: getsize(184px);
    }
    .desc {
      margin-top: getsize(48px);
      font-size: getsize(30px);
      color: #666666;
    }
  }
</style>
